/*
 * Below is an array of Notifictions that must be skipped as errors. They are not Error Notifications
 */
export const shopNotificationKeys = ['promotion-discount-added']
export const CONFIGURED_SYSTEM_NOT_ALLOWED_IN_COUNTRY_KEY = 'CONFIGURED_SYSTEM_NOT_ALLOWED_IN_COUNTRY'
